export function parseJwt(token: string): any {
  if (!token) return {};

  const base64Url = token.split(".")[1];
  // JWT dùng base64url, cần đổi về base64 chuẩn
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

  // decode base64 → binary string
  const binary = atob(base64);
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));

  // đúng UTF-8 nè
  const json = new TextDecoder("utf-8").decode(bytes);

  return JSON.parse(json);
}
